import { getExpoEASConstant } from "../../../utils/expoConstants";

const IN_APP_ORIGIN = "https://patron.whoosh.invalid";
const SCHEME_PREFIX = /^([a-z][a-z\d+.-]*):/i;
const LOOPBACK_HTTP_PREFIX =
  /^http:\/\/(?:localhost|127\.0\.0\.1|\[::1\])(?::\d+)?(?:[/?#]|$)/i;

/**
 * Accepts in-app patron paths, HTTPS destinations, and local loopback HTTP URLs.
 * HTTPS destinations remain unrestricted because SSO providers use club-specific hosts.
 */
export const isSafePostLoginRedirect = (redirectPath: string): boolean => {
  const containsControlCharacter = Array.from(redirectPath).some(
    (character) => {
      const characterCode = character.charCodeAt(0);
      return characterCode <= 0x1f || characterCode === 0x7f;
    }
  );

  if (
    !redirectPath ||
    containsControlCharacter ||
    redirectPath.includes("\\")
  ) {
    return false;
  }

  if (redirectPath.startsWith("/")) {
    if (!redirectPath.startsWith("/patron/") || redirectPath.startsWith("//")) {
      return false;
    }

    try {
      const parsedPath = new URL(redirectPath, IN_APP_ORIGIN);
      return (
        parsedPath.origin === IN_APP_ORIGIN &&
        parsedPath.pathname.startsWith("/patron/")
      );
    } catch (_error) {
      return false;
    }
  }

  const scheme = redirectPath.match(SCHEME_PREFIX)?.[1]?.toLowerCase();
  const isHttps = scheme === "https" && /^https:\/\//i.test(redirectPath);
  const isLoopbackHttp =
    scheme === "http" && LOOPBACK_HTTP_PREFIX.test(redirectPath);

  if (!isHttps && !isLoopbackHttp) {
    return false;
  }

  try {
    const parsedUrl = new URL(redirectPath);
    if (isHttps) {
      return parsedUrl.protocol === "https:" && Boolean(parsedUrl.hostname);
    }

    const deployEnv = getExpoEASConstant("deployEnv");
    return (
      (deployEnv === "local" || deployEnv === "e2e") &&
      parsedUrl.protocol === "http:" &&
      ["localhost", "127.0.0.1", "[::1]"].includes(parsedUrl.hostname) &&
      !parsedUrl.username &&
      !parsedUrl.password
    );
  } catch (_error) {
    return false;
  }
};
